export const resolveOrgRoute = (href: string, orgId: string): string => {
  if (href.includes(':orgId')) {
    return href.replace(':orgId', orgId);
  }
  return `${href}/${orgId}`;
};

export const resolvePartnerRoute = (href: string, partnerId: string): string => {
  if (href.includes(':id')) {
    return href.replace(':id', partnerId);
  }
  return `${href}/${partnerId}`;
};
